"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _preact = require("preact");

var _absoluteUrlRuntime = require("@insided/shared/utils/absoluteUrlRuntime");

var _classnames = _interopRequireDefault(require("classnames"));

var _translations = require("@insided/deprecated-libs/translationsUtils/translations");

var Badges = function Badges(props) {
  var recentBadge = props.recentBadge,
      count = props.count;
  return (0, _preact.h)("div", {
    className: (0, _classnames.default)('list--badges-small is-hidden-S badges-aligned')
  }, (0, _preact.h)("img", {
    alt: (0, _translations.t)('Forum', 'alt.badge.img'),
    title: recentBadge === null || recentBadge === void 0 ? void 0 : recentBadge.title,
    src: (0, _absoluteUrlRuntime.resolveUrl)(recentBadge === null || recentBadge === void 0 ? void 0 : recentBadge.url)
  }), count > 1 ? (0, _preact.h)("span", {
    className: "badgeCounter"
  }, "+".concat(count - 1)) : null);
};

var _default = Badges;
exports.default = _default;